(() => {
  const selector = ':is(.button, .button-secondary, .button-custom):not(:disabled, [aria-disabled="true"], [aria-busy="true"], .button-unstyled, .localization-selector, .header-actions__action, .cart-items__remove, .quick-add__button, .quick-add *, localization-form-component *, .hatlab :where(:not(.hatlab-pager .button)), .bulk-order *, .shopify-payment-button__button)';
  const media = matchMedia('(prefers-reduced-motion: no-preference) and (hover: hover) and (pointer: fine)');
  let active = null;
  let bounds = null;
  let frame = 0;
  let point = null;
  let strength = 8;

  const reset = () => {
    cancelAnimationFrame(frame);
    frame = 0;
    active?.style.removeProperty('--button-magnetic-x');
    active?.style.removeProperty('--button-magnetic-y');
    active = null;
    bounds = null;
  };

  document.addEventListener('pointerover', (event) => {
    if (!media.matches || event.pointerType === 'touch') return;
    const button = event.target.closest?.(selector);
    if (button === active) return;
    reset();
    if (!button) return;
    const style = getComputedStyle(button);
    if (style.getPropertyValue('--button-motion').trim() !== 'magnetic') return;
    strength = Math.max(2, Math.min(16, Number.parseFloat(style.getPropertyValue('--button-magnetic-strength')) || 8));
    active = button;
    bounds = button.getBoundingClientRect();
  }, { passive: true });

  document.addEventListener('pointermove', (event) => {
    if (!active) return;
    if (!active.isConnected || !active.matches(selector) || event.buttons || !media.matches) {
      reset();
      return;
    }
    point = { x: event.clientX, y: event.clientY };
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      if (!active || !bounds) return;
      if (!active.isConnected || !active.matches(selector) || !media.matches) {
        reset();
        return;
      }
      const x = Math.max(-strength, Math.min(strength, ((point.x - bounds.left - bounds.width / 2) / Math.max(1, bounds.width / 2)) * strength));
      const y = Math.max(-strength * 0.75, Math.min(strength * 0.75, ((point.y - bounds.top - bounds.height / 2) / Math.max(1, bounds.height / 2)) * strength * 0.75));
      active.style.setProperty('--button-magnetic-x', `${x.toFixed(2)}px`);
      active.style.setProperty('--button-magnetic-y', `${y.toFixed(2)}px`);
    });
  }, { passive: true });

  document.addEventListener('pointerout', (event) => {
    if (active && !active.contains(event.relatedTarget)) reset();
  }, { passive: true });
  document.addEventListener('pointercancel', reset, { passive: true });
  document.addEventListener('pointerdown', reset, { passive: true });
  document.addEventListener('scroll', reset, { passive: true, capture: true });
  window.addEventListener('blur', reset);
  window.addEventListener('resize', reset, { passive: true });
  media.addEventListener('change', reset);
  document.addEventListener('shopify:section:unload', reset);
})();
